import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { notBlank } from "../../../util/ext";

import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  label: {
    minWidth: 0,
    paddingRight: theme.spacing(5),
  },

  tooltip: {
    borderRadius: "20px",
    padding: "5px 12px",
    margin: "0",
  },
}));

const SidebarTreeItemLabel = props => {
  const { icon, labelText, tooltipLabel, TypographyProps, dropRef } = props;

  const classes = useStyles();
  return (
    <Grid ref={dropRef} container wrap="nowrap" alignItems="center">
      {icon && (
        <Grid item style={{ paddingRight: "15px" }}>
          {icon}
        </Grid>
      )}

      <Grid item className={classes.label}>
        {notBlank(tooltipLabel) ? (
          <Tooltip
            enterDelay={300}
            classes={{ tooltip: classes.tooltip }}
            title={tooltipLabel}
            placement="right"
          >
            <Typography noWrap {...TypographyProps}>
              {labelText}
            </Typography>
          </Tooltip>
        ) : (
          <Typography noWrap {...TypographyProps}>
            {labelText}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default SidebarTreeItemLabel;
